import request from '@/utils/request'
export function getMismatchAccountList(project) {
    return request({
      url: '/api/reports/bankaccount/misbalance/' + project,
      method: 'get'
    });
  }
